import {Injectable} from '@angular/core';
import {ProxyStreamService} from '@core/interfaces/common/proxyStream';
import {ProxyStreamApi} from '@core/backend/common/api/proxyStream.api';
import {Observable} from 'rxjs';

@Injectable()
export class ProxyStreamServiceImpl extends ProxyStreamService {
    constructor(private api: ProxyStreamApi) {
        super();
    }
    public mediaFileStreaming(signedUrl: string): Observable<Blob> {
        return this.api.mediaFileStreaming(signedUrl);
    }
}
